module.exports = __webpack_public_path__ + "img/unArchive.366bfcc5.svg";